import { dispatch } from '../dispatcher';
import common from './common';
import moment from 'moment';

const ResidentialLocationActions = {

  getDiningCourts: function () {
    common.promiseXHR('GET', 'v2/locations')
      .then(result => {
        dispatch({
          type: 'diningCourts/fetch',
          locations: result.data.Location
        });
      });
  },
  getTypes: function () {
    common.promiseXHR('GET', 'v2/locations')
      .then(result => {
        dispatch({
          type: 'types/fetch',
          types: result.data.Types
        });
      });
  },
  getMenu: function (locationId, date) {
    return new Promise((resolve, reject) => {
      common.promiseXHR('GET', 'v2/diningCourtMenus/' + locationId + '/' + common.dateToString(date))
        .then(result => {
          resolve(result.data);
        });
    });
  },

  updateMenu: function (locationId, date, menu) {
    return new Promise((resolve, reject) => {
      common.promiseXHR('PUT', 'v2/diningCourtMenus/' + locationId + '/' + common.dateToString(date), menu)
        .then(result => {
          resolve();
        });
    });
  },

  //gets item data and the schedule
  getMenuItem: function (id) {
    common.promiseXHR('GET', 'v2/items/' + id)
      .then(item => {
        common.promiseXHR('GET', 'v2/items/' + id + "/schedule")
          .then(upcoming => {
            dispatch({
              type: 'menuItem/fetch',
              item: item.data,
              upcoming: upcoming.data.ItemAppearance
            });
          });
      });
  },
  getLocationMenus: function (locationId, date) {
    return new Promise((resolve, reject) => {
      common.promiseXHR('GET', 'v2/locations/' + locationId + '/' + date)
        .then(menu => {
          resolve(menu.data);
        })
        .catch(e => { reject(); });
    });
  },
  getNormalHoursPeriods: function () {
    common.promiseXHR('GET', 'v2/locations/normalHours/periods')
      .then(result => {
        dispatch({
          type: 'residentialNormalHoursPeriods/fetch',
          periods: result.data.Period
        });
      });
  },

  updateNormalHoursPeriod: function (period) {
    common.promiseXHR('PUT', 'v2/locations/normalHours/periods/' + period.Id, period)
      .then(result => {
        dispatch({
          type: 'residentialNormalHoursPeriods/update',
          period: period
        });
      });
  },

  createNormalHoursPeriod: function (period) {
    return new Promise((resolve, reject) => {
      common.promiseXHR('POST', 'v2/locations/normalHours/periods', period)
        .then(result => {
          period.Id = common.getIdFromLocationHeader(result.xhr);
          dispatch({
            type: 'residentialNormalHoursPeriods/create',
            period: period
          });

        });
    });
  },

  deleteNormalHoursPeriod: function (periodId) {
    common.promiseXHR('DELETE', "v2/locations/normalHours/periods/" + periodId)
      .then(result => {
        dispatch({
          type: 'residentialNormalHoursPeriods/delete',
          periodId: periodId
        });
      });
  },

  getNormalHoursForLocation: function (periodId, locationId) {
    return new Promise((resolve, reject) => {
      common.promiseXHR('GET', 'v2/locations/normalHours/periods/' + periodId + '/location/' + locationId)
        .then(result => {
          dispatch({
            type: 'residentialNormalHours/fetch',
            hours: result.data.Hours,
            isPublished: result.data.IsPublished,
            periodId: periodId,
            locationId: locationId
          });
          resolve(result.data);
        })
        .catch(e => { reject(); });
    });
  },

  setNormalHoursForLocation: function (periodId, locationId, hours, isPublished) {
    const body = {
      IsPublished: isPublished,
      Hours: hours
    };
    common.promiseXHR('PUT', 'v2/locations/normalHours/periods/' + periodId + '/location/' + locationId, body)
      .then(result => {
        dispatch({
          type: 'residentialNormalHours/set',
          hours: hours,
          isPublished: isPublished,
          periodId: periodId,
          locationId: locationId
        });
      });
  },

  getLineLength: function () {
    common.promiseXHR('GET', 'v2/lineLength/all')
      .then(result => {
        dispatch({
          type: 'lineLength/fetch',
          reports: result.data.LineLengthReport
        });
      });
  },

  getBallot: function (locationName) {
    return common.promiseXHR('GET', 'v2/lineLength/ballot/' + locationName);
  },

  castLineLengthBallot: function (locationName, choice) {
    const xml = '<UserLineLengthVote>'
      + '<LocationName>' + locationName + '</LocationName>'
      + '<Choice>' + choice + '</Choice>'
      + '</UserLineLengthVote>';
    return common.promiseXHR('POST', 'v2/lineLength/vote', xml, 'application/xml');
  },

  fetchPublishStatus: function (year, month) {
    return new Promise((resolve, reject) => {
      common.promiseXHR('GET', 'v2/diningCourtMenus/publishStatus?year=' + year + '&month=' + month)
        .then(result => {
          dispatch({
            type: 'publishStatus/fetch',
            publishStatus: result.data,
            year: year,
            month: month
          });
          resolve();
        });
    });
  },

  setPublishStatus: function (locationId, date, publishStatus) {
    return new Promise((resolve, reject) => {

      const body = {
        IsPublished: publishStatus ? 'true' : 'false'
      };

      common.promiseXHR('PUT', 'v2/diningCourtMenus/publishStatus/' + locationId + '/' + common.dateToString(date), body)
        .then(result => {
          const d = moment(date);
          this.fetchPublishStatus(d.year(), d.month() + 1).then(result => { resolve(); });
        });
    });
  },

  setItemBlacklist: function (itemId, isBlacklisted) {
    return new Promise((resolve, reject) => {
      common.promiseXHR('POST', 'v2/items/' + itemId + '/blacklist?isBlacklisted=' + (isBlacklisted ? 'true' : 'false'))
        .then(result => {
          resolve();
        })
        .catch(e => {
          reject();
        });
    });
  }
};

export default ResidentialLocationActions;